// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__M_A4k","containerItemsCenter":"Skeleton_containerItemsCenter__2drtp"};